export const TERMS_TITLE = 'Пользовательское соглашение';

export const TERMS_SUBTITLE = 'Прокрутите текст до конца, чтобы продолжить';

export const TERMS_TEXT = `
Договор-акцепт возмездного оказания услуг
г. Бишкек «___» __________ 2026 г.
ОсОО «GS GROUP» - оказывающий услуги почтовой связи на основании лицензии
№ 24-0633-КР от 09.04.2024г., выданной Службой по регулированию и надзору в отрасли
связи при Министерстве цифрового развития Кыргызской Республики, в лице
Генерального директора Мадумарова Элеса Аскаровича, действующего на основании
Устава, именуемое в дальнейшем «Исполнитель», с одной стороны и,
гражданка Кыргызской Республики – ………………………………….
………………………., …………….. года рождения, номер паспорта ID/AN……………,
выдан МКК………….. от ………………… года, зарегистрированный по адресу:
Кыргызская Республика, г. Бишкек, ………………район, улица………………., дом …. кв.
…….., именуемый в дальнейшем «Заказчик» с другой стороны, при совместном
упоминании именуемые «Стороны», заключили настоящий договор о нижеследующем
(далее Договор):
ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ
Оферта - адресованное одному или нескольким конкретным лицам предложение, которое
достаточно определённо и выражает намерение лица, сделавшего предложение, считать
себя заключившим договор с адресатом, которым будет принято предложение.
Исполнитель – Общество с ограниченной ответственностью «GS GROUP»
Заказчик – любое физическое лицо и/или юридическое лицо, желающее получить услуги
почтовой связи.
Стороны – совместно именуемые по тексту настоящего договора Заказчик и Исполнитель.
Информационные услуги, курсы – услуги, предоставляемые Исполнителем Заказчику по
финансовой грамотности, в соответствии с выбранным пакетом.
Почтовая посылка — упакованное почтовое отправление с вложением товаров, предметов
или корреспонденции, разрешённых к международной авиаперевозке.
Услуги по авиаперевозке почтовых посылок – комплекс услуг, оказываемых
Исполнителем, включающий организацию и осуществление перевозки почтовых посылок
воздушным транспортом, в том числе прием, обработку, погрузку, авиаперевозку и
передачу почтовых отправлений в пункте назначения в соответствии с условиями Договора
и действующим законодательством
1. ПРЕДМЕТ ДОГОВОРА
1.1. В соответствии с настоящим договором Исполнитель обязуется оказать Заказчику
услуги по авиаперевозке почтовых посылок (далее-Груз) в соответствии с заявкой, а
Заказчик обязуется принять и оплатить информационные услуги.
1.2. Услуги включают, но не ограничиваются:
• приём почтовых посылок;
• проверку упаковки и соответствия требованиям перевозки;
• обработку, сортировку и консолидацию;
• авиаперевозку;
• организацию передачи посылок в пункте назначения.
1.3. Настоящий Договор является предложением (офертой) Исполнителя, направленным в
адрес Заказчика в порядке, предусмотренном Гражданским кодексом Кыргызской
Республики, о заключении настоящего договора.
1.4. Принятием (акцептом) настоящей Оферты Заказчиком считается направление
Исполнителю ответного сообщения с выражением согласия (в том числе через
мессенджеры, электронную почту или иные электронные каналы связи), совершением
Заказчиком действий, свидетельствующих о намерении воспользоваться услугами
Исполнителя (оплата и др.).
1.5. С момента получения Исполнителем акцепта от Заказчика настоящий Договор
считается заключённым и вступает в силу на условиях, изложенных в настоящей
Оферте.
2. ПОРЯДОК ОКАЗАНИЯ УСЛУГ
2.1. Приём почтовых посылок осуществляется Исполнителем в согласованном пункте на
территории Японии.
2.2. Исполнитель вправе отказать в приёме посылок, не соответствующих требованиям
авиационной, таможенной или почтовой безопасности.
2.3. Авиаперевозка осуществляется регулярными или чартерными рейсами по выбору
Исполнителя.
2.4. По прибытии в Кыргызстан почтовые посылки передаются для таможенного
оформления и дальнейшей доставки.
3. СТОИМОСТЬ УСЛУГ И ПОРЯДОК РАСЧЕТОВ
3.1. Стоимость услуг определяется на основании действующих тарифов Исполнителя.
3.2. Оплата услуг производится в порядке и сроки, установленные Исполнителем.
3.3. Все банковские комиссии оплачиваются Заказчиком, если иное не согласовано
сторонами.
3.4. Все расчеты должны быть произведены в национальной валюте - кыргызских сомах.
3.5. Оплата производится как в наличной, так и в безналичной форме.
3.6.Услуга будет считаться оплаченной с момента поступления денежных средств на счет
либо в кассу Исполнителя.
4. ПРАВА И ОБЯЗАННОСТИ СТОРОН
4.1. Исполнитель обязан:
4.1.1. обеспечить надлежащую организацию авиаперевозки;
4.1.2. соблюдать правила международных авиаперевозок
4.1.3. обеспечить сохранность посылок в пределах своей ответственности.
4.2. Исполнитель вправе:
4.2.1. привлекать третьих лиц для исполнения Договора;
4.2.2. приостанавливать оказание услуг при нарушении Заказчиком условий Договора.
4.3. Заказчик обязуется:
4.3.1. предоставлять достоверную информацию о содержимом посылок;
4.3.2. обеспечить надлежащую упаковку;
4.3.3. оплатить услуги в полном объёме.
5. РАЗРЕШЕНИЕ СПОРОВ ПО ДОГОВОРУ
5.1. Все споры или разногласия, возникающие между сторонами по настоящему
договору или в связи с ним, разрешаются путем переговоров между сторонами.
5.2. В случае невозможности разрешения разногласий путем переговоров между
сторонами, они подлежат рассмотрению в суде общей юрисдикции в соответствии с
требованиями законодательства КР.
6. СОГЛАШЕНИЕ ОБ ЭЛЕКТРОННОМ ДОКУМЕНТООБОРОТЕ
6.1. Стороны подтверждают, что моментом подписания настоящего публичного
договора - оферта является подтверждение Заказчика о принятии условий
настоящего договора посредством использования электронной почты или
мессенджеров (WhatsApp, Viber, Telegram и другие).
6.2. Электронная переписка (с использованием электронной почты или мессенджеров)
является основным способом обмена информацией между Сторонами для
оперативного решения вопросов, возникающих при исполнении договора.
6.3. Статусом юридически значимой электронной переписки обладают любые
входящие и исходящие электронные сообщения, отправленные с указанных в
договоре адресов электронной почты или мессенджеров на указанные номеров
телефонов и отправленные на указанные в настоящем договоре адреса электронной
почты или мессенджеров на указанные номер телефона. Стороны договорились, что
они будут использовать исключительно следующие контакты (адрес электронной
почты и/или номер телефона мессенджеров включительно):
От имени Исполнителя: jpex.log@gmail.com; +996701500002;
От имени Заказчика – __________________________________________________;
6.4. Стороны обязуются сохранять конфиденциальность доступов к указанным каналам
связи и не передавать данных для доступа к ним их третьим лицам.
7. ОТВЕТСТВЕННОСТЬ СТОРОН
7.1. В случае неисполнения или ненадлежащего исполнения сторонами обязательств по
настоящему Договору они несут ответственность в соответствии с
законодательством Кыргызской Республики.
7.2. Стороны освобождаются от ответственности за неисполнение или ненадлежащее
исполнение обязательств по Договору на время действия непреодолимой силы. Под
непреодолимой силой понимаются чрезвычайные и непреодолимые при данных
условиях обстоятельства, препятствующие исполнению своих обязательств
Сторонами по Договору. К ним относятся: стихийные явления (землетрясения,
наводнения и т. п.), обстоятельства общественной жизни (задержки авиа рейсов на
транзитных зонах, военные действия, чрезвычайные положения, крупнейшие
забастовки, эпидемии и т. п.), запретительные меры государственных органов
(запрещение перевозок, валютные ограничения, международные санкции запрета на
торговлю и т. п.). В течение этого времени Стороны не имеют взаимных претензий,
и каждая из Сторон принимает на себя свой риск последствий форс-мажорных
обстоятельств.
7.3. Заказчик обязан не допускать распространение любыми способами недостоверной
информации об услугах Исполнителя, а также информацию порочащую деловую
репутацию Исполнителя. За неисполнения настоящего пункта Заказчик несет
ответственность в виде штрафа в размере 1 000 000 (один миллион) сомов за каждый
установленный случай.
7.4. Исполнитель не несет ответственность перед Заказчиком за предоставление любой
информации по ошибочно указанным данным не Заказчику, а третьим лицам, даже
если в них содержится часть персональных данных Заказчика.
8. ИЗМЕНЕНИЕ, РАСТОРЖЕНИЕ ДОГОВОРА
8.1.Основания расторжения настоящего Договора предусмотрены законодательством
Кыргызской Республики, а порядок возврата денежных средств - положениями
данного раздела настоящего Договора.
9. ОБРАБОТКА И ЗАЩИТА ПЕРСОНАЛЬНЫХ ДАННЫХ
9.1. Заказчик (физическое лицо) предоставляет Исполнителю своё согласие на сбор,
обработку, хранение и использование своих персональных данных, включая, но не
ограничиваясь: фамилией, именем, отчеством, паспортными данными,
идентификационным номером, адресом проживания, контактными телефонами,
адресом электронной почты, банковскими реквизитами и иными данными,
необходимыми для исполнения настоящего Договора.
9.2. Персональные данные Заказчика обрабатываются исключительно в целях:
9.2.1. заключения и исполнения настоящего Договора;
9.2.2. ведения бухгалтерского и налогового учёта;
9.2.3. осуществления расчётов между Сторонами;
9.2.4. предоставления отчётности в государственные органы в соответствии с
законодательством Кыргызской Республики.
9.3. Исполнитель обязуется обеспечивать конфиденциальность полученных
персональных данных и принимать необходимые организационные и технические
меры для их защиты от несанкционированного доступа.
9.4. Обработка персональных данных осуществляется как с использованием
автоматизированных средств, так и без них, в соответствии с требованиями
законодательства Кыргызской Республики о защите персональных данных.
9.5. Исполнитель вправе передавать персональные данные Заказчика только в случаях,
предусмотренных законодательством Кыргызской Республики, либо при
необходимости исполнения настоящего Договора (например, при передаче данных
в бухгалтерию, банк, таможенные или налоговые органы).
9.6. Персональные данные Заказчика хранятся в течение срока действия настоящего
Договора. Заказчик вправе отозвать своё согласие на обработку персональных
данных путём направления письменного уведомления Исполнителю, при этом отзыв
согласия может повлечь невозможность исполнения Договора.
10. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
10.1. Во всем, что не урегулировано настоящим соглашением стороны руководствуются
законодательством КР.
10.2. Настоящий договор вступает в силу с подписания договора, и действует до полного
выполнения обязательств Сторонами.
10.3. Принимая условия настоящего договора, Заказчик выражает свое согласие на
обработку его персональных данных в соответствии с Законом КР «об информации
персонального характера», а также на получение информации на его электронную
почту и в мессенджеры (WhatsApp, Viber, Telegram и другие).
10.4. Стороны признают, что направление Оферты и Акцепта посредством
электронных каналов связи (в том числе через мессенджеры, электронную почту и
иные информационные системы) соответствует письменной форме сделки
Гражданского кодекса Кыргызской Республики и имеет ту же юридическую
силу, что и собственноручное подписание договора на бумажном носителе.
10.5.Признание судом какого-либо положения настоящего договора недействительным
или не подлежащим принудительному исполнению не влечёт недействительности
или неисполнимости иных положений Договора.
10.6.Все споры по исполнению настоящего Договора, возникшие между Сторонами,
разрешаются путем переговоров. Срок ответа на претензию – 10 (десять) рабочих
дней со дня ее получения. При несоблюдении любой из Сторон всех перечисленных
выше условий обязательный претензионный порядок не считается соблюденным.
10.7.При недостижении согласия между Сторонами по поводу возникших споров путем
переговоров, спор передается на рассмотрение в суд в соответствии с действующим
законодательством Кыргызской Республики.
`;

